/* eslint-disable @typescript-eslint/no-unused-vars */
import { FXS_EMAIL_DOMAIN } from 'constants/email';

import { User } from '../models/user';

let userToken = null;
let currentUser = null;
let getUserPromise = null;

export function getCookie(name) {
	const dc = document.cookie;
	const prefix = `${name}=`;
	let begin = dc.indexOf(`; ${prefix}`);
	if (begin === -1) {
		begin = dc.indexOf(prefix);
		if (begin !== 0) return undefined;
	} else {
		begin += 2;
	}
	let end = document.cookie.indexOf(';', begin);
	if (end === -1) {
		end = dc.length;
	}
	return decodeURI(dc.substring(begin + prefix.length, end));
}

export async function getUser(): Promise<User> {
	if (!userToken) {
		userToken = getCookie(window.config.Variables.AuthenticationCookie);
		if (!userToken) {
			return null;
		}
	}

	if (currentUser) return currentUser;
	if (getUserPromise) return getUserPromise;

	getUserPromise = await fetch(
		`${process.env.REACT_APP_GATEWAY_URL}/getuser`,
		{
			method: 'GET',
			headers: {
				Accept: 'application/json',
				Authorization: `Bearer ${userToken}`
			}
		}
	)
		.then((res) => {
			getUserPromise = null;
			if (res.status === 200) {
				return res.json().then((user) => {
					currentUser = {
						id: user.id,
						isPremium: user.isPremium,
						email: user.email,
						phone: user.phone,
						country: user.countryCode,
						name: user.name,
						token: userToken,
						isEmployee: user.email.endsWith(FXS_EMAIL_DOMAIN),
						emailEncrypted: user.emailEncrypted
					};
					window.userInfo = currentUser;
					return currentUser;
				});
			}
			return null;
		})
		.catch((err) => console.log(err));

	return getUserPromise;
}
